import React from 'react';
import styled from 'styled-components';

import projects from './projects';

const Timeline = styled.div`
  margin-left: calc(1rem - 2px);
  padding-left: 25px;
  padding-bottom: 1rem;
  position: relative;
`

const createDescription = description => ({
  __html: description,
})

export const Portfolio = () => (
  <section className="o-section t-section  ">

    <div className="o-section__header-bg t-section__header"></div>
    <div className="o-section__content-bg t-section__content"></div>

    <div className="o-container">
      <div className="o-section__container">

        <header className="o-section__header t-section__header">
          <div className="o-content">
            <h2 className="o-section__heading">Portfolio</h2>
          </div>
        </header>

        <div className="o-section__content t-section__content  u-pb-0">

          <Timeline>
            { projects.map(project => (
              <div className="c-timeline__item" key={project.name}>
                <div className="o-content">
                  <div className="o-grid">
                    <div className="o-grid__col-md-5">
                      <div className="c-work__timeframe">{project.date}</div>
                      <h3 className="c-work__heading">{project.name}</h3>
                      <h4 className="c-work__title">
                        {!!project.url && (
                          <a href={project.url} target="_blank" rel="noopener noreferrer" name={`External link to ${project.name} demo`}>demo</a>    
                        )}
                        {!!project.repo && !!project.url && ' - '}
                        {!!project.repo && (
                          <a href={project.repo} target="_blank" rel="noopener noreferrer" name={`External link to ${project.name} repository`}>repository</a>    
                        )}
                      </h4>
                    </div>
                    <div className="o-grid__col-md-7" dangerouslySetInnerHTML={createDescription(project.description)} />
                  </div>
                </div>
              </div>
            )) }
          </Timeline>

        </div>

      </div>
    </div>

  </section>
);



// WEBPACK FOOTER //
// ./src/components/Portfolio/Portfolio.js